import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import {
  AmbianceEnum,
  DataSortEnum,
  FilterBudgetTypeEnum,
  FilterDatesDto,
  FilterLocationDto,
  FiltersEnum,
  HouseTypeEnum,
  Transport_Type,
  TransportTimeRange,
  TravelTypeEnum,
} from '../../../lib/graphql'

export interface ISearchFormHeaderProps {
  travelType: TravelTypeEnum
  location?: FilterLocationDto
  dates?: FilterDatesDto & { flexible?: boolean }
  adults?: number
  houseCanBePrivatised?: boolean
  budget?: {
    budgetMin: number
    budgetMax: number
  }
}

export interface ISearchFormProps extends ISearchFormHeaderProps {
  ambiance?: { [key in AmbianceEnum]?: boolean }
  houseType?: { [key in HouseTypeEnum]?: boolean }
  budget: {
    budgetMin: number
    budgetMax: number
    filterBudgetType?: FilterBudgetTypeEnum
  }
  numberOfBedrooms?: {
    bedroomsMin?: number
    bedroomsMax?: number
  }
  filters?: { [key in FiltersEnum]?: boolean }
  sortBy: DataSortEnum
  isAutonomousBookingAvailable?: boolean
  travelTime?: {
    transportTime?: TransportTimeRange
    transportType: Transport_Type
  }
}

interface IHouseSearchLayout {
  header: React.ReactNode
  sidebar: React.ReactNode
  main: React.ReactNode
  showSortSelector?: boolean
}

export const HouseSearchLayout = ({
  header,
  sidebar,
  main,
  showSortSelector,
}: IHouseSearchLayout) => {
  return (
    <div
      className={clsx(s.container, {
        [s.SortSelectorHidden]: !showSortSelector,
      })}
    >
      {header}
      <div className={s.body}>
        <div className={s.leftContainer}>{sidebar}</div>
        <div className={s.rightContainer} data-testid='house-search-results'>
          {main}
        </div>
      </div>
    </div>
  )
}
